import React, { FC, useEffect } from 'react';
import { useBoolean } from '../../../utils/hooks/useBoolean';
import { IOuter } from './Loader.types';
import { Loader as WixLoader } from '@wix/design-system';

export const Loader: FC<IOuter> = ({ defer = 50, ...otherProps }) => {
  const { value: isVisible, setTrue: show } = useBoolean(defer < 0);

  useEffect(() => {
    if (isVisible) {
      return;
    }

    const timeoutId = setTimeout(show, defer);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  if (!isVisible) {
    return null;
  }

  return <WixLoader {...otherProps} />;
};
